// extracted by mini-css-extract-plugin
export default {"side-drawer":"SideDrawer_side-drawer__+OBiL"};